/** Copyright (c) 2021 T. Rowe Price. All rights reserved. */

export const REQUESTED_TOTAL_PERFORMANCE = 'REQUESTED_TOTAL_PERFORMANCE';
export const requestedTotalPerformance = () => {
  return {
    type: REQUESTED_TOTAL_PERFORMANCE
  };
};

export const RECEIVED_TOTAL_PERFORMANCE = 'RECEIVED_TOTAL_PERFORMANCE';
export const receivedTotalPerformance = (totalPerformance) => {
  return {
    type: RECEIVED_TOTAL_PERFORMANCE,
    totalPerformance
  };
};

export const ERROR_TOTAL_PERFORMANCE = 'ERROR_TOTAL_PERFORMANCE';
export const errorTotalPerformance = (error) => {
  return {
    type: ERROR_TOTAL_PERFORMANCE,
    error
  };
};
